// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__fW115"};